// context/SocketContext.js
import React, { createContext, useEffect, useRef, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { Base_Url } from "../../BaseURL/BaseUrl";

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const [notificationSignal, setNotificationSignal] = useState(null);
    const connectionRef = useRef(null);

    useEffect(() => {
        const loginData = JSON.parse(localStorage.getItem("login"));
        const token = loginData?.token;

        const connectSocket = async () => {
            const connection = new signalR.HubConnectionBuilder()
                .withUrl(`${Base_Url}/notificationHub`, {
                    accessTokenFactory: () => token, // ✅ pass token here
                })
                .withAutomaticReconnect()
                .build();

            connection.on("ReceiveNotification", (data) => {
                console.log("New notification received:", data);
                setNotificationSignal(data);
            });

            try {
                await connection.start();
                console.log("SignalR connected");
                connectionRef.current = connection;
            } catch (error) {
                console.error("SignalR connection failed", error);
            }
        };

        if (token) {
            connectSocket();
        }

        return () => {
            connectionRef.current?.stop();
        };
    }, []);

    return (
        <SocketContext.Provider value={{ notificationSignal }}>
            {children}
        </SocketContext.Provider>
    );
};
